<template>
  <div @click="OpenChat" style="color: yellow; cursor: pointer;" class="text-center">Need Help?</div>  
</template>

<script>
import store from "../veux/store";

export default {
    name: 'Zendesk',
    components: {
    },
  data() {
    return {
    }
  },
  methods: {
      OpenChat() {
        if (store.getters.currentUser) {
            window.zE('webWidget', 'prefill', {
            name: {
                value: `${store.getters.currentUser.Firstname} ${store.getters.currentUser.Surname}` ,
                readOnly: true // optional
            },
            email: {
                value: store.getters.currentUser.EmailDetail,
                readOnly: true // optional
            },
            // TODO Add a default Phone to teh Contact Record
            // phone: {
            //   value: JSON.parse(localStorage.getItem("Contact")).contact.Default_Phone,
            //   readOnly: true // optional
            // }
            });
        }
        window.zE('webWidget', 'show');
        window.zE('webWidget', 'open');
        window.zE('webWidget:on', 'close', function () {
            window.zE('webWidget', 'hide');
        });
    }
  },
  computed: {},
}
</script>
<style>

</style>